// extracted by mini-css-extract-plugin
export default {"sidemenu-main":"Sidemenu_sidemenu-main__9yt12","avatar":"Sidemenu_avatar__hJPtH","name":"Sidemenu_name__clKRy","options":"Sidemenu_options__nvuqD","active":"Sidemenu_active__NTH4N"};